import React from 'react';
import ReactToPrint from 'react-to-print';
import { Button,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableRow} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Print from '@material-ui/icons/Print';
import { format } from 'date-fns';
import classnames from 'classnames';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    margin: theme.spacing.unit * 2,
  },
  button: {
    margin: theme.spacing.unit,
  },
  icon: {
    marginRight: theme.spacing.unit,
  },
  direita: {
    textAlign: 'right',
    width: '50%',
  },
  div: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    textAlign: 'center',
  },
  typography: {
    ...theme.mixins.gutters(),
    paddingBottom: theme.spacing.unit * 2,
    textAlign: 'center',
  },
  cellCancelada: {
    backgroundColor: '#f2dede',
  },
  fontTableLink: {
    fontSize: 12,
    cursor: 'pointer',
    color: 'blue',
    textDecoration: 'underline'
  },
});

class ComponentToPrint extends React.Component {
  render () {
    const { acerto, classes } = this.props;
    return (
      <Paper className={classes.root} elevation={1}>
        <Typography variant='title' className={classes.typography}>
          Dados do Acerto - Pagamento Antecipado
        </Typography>
        <Table padding={'default'}>
          <TableBody>
            <TableRow>
              <TableCell className={classes.direita}>Número do Protocolo:</TableCell>
              <TableCell>{acerto.numProtocolo}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.direita}>Matrícula:</TableCell>
              <TableCell>{acerto.numMatricula}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.direita}>Nome:</TableCell>
              <TableCell>{acerto.nomeBeneficiario}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.direita}>Data do Efeito Financ.:</TableCell>
              <TableCell>{format(new Date(acerto.dtaEfeitoFinanc), 'DD/MM/YYYY')}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.direita}>Valor do Acerto:</TableCell>
              <TableCell>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(acerto.valAcerto)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.direita}>Banco:</TableCell>
              <TableCell>{'001'}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.direita}>CNPJ:</TableCell>
              <TableCell>{'08.512.284/0001-07'}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.direita}>Agência:</TableCell>
              <TableCell>{'4200-5'}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.direita}>Conta Corrente:</TableCell>
              <TableCell>{'45.000-6'}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.direita}>Observação:</TableCell>
              <TableCell>{acerto.txtObservacao === ' ' ? '-' : acerto.txtObservacao}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classnames(classes.direita, acerto.indCancelado === 'S' ? classes.cellCancelada : classes.direita)}>Situação do Acerto:</TableCell>
              {acerto.indCancelado === 'S'
                ? <TableCell className={classes.cellCancelada}>CANCELADO</TableCell>
                : <TableCell>{acerto.desEstado}</TableCell>}
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
    );
  }
}

class PrintComponentAcertoCoparticipacao extends React.Component {
  render () {
    const { classes, acerto } = this.props;
    return (
      <div>
        <ComponentToPrint
          ref={el => (this.componentRef = el)}
          acerto={acerto}
          classes={classes} />
        <ReactToPrint
          trigger={() =>
            <div className={classes.div}>
              <Button
                variant='contained'
                color='primary'
                className={classes.button}
                href='#'>
                <Print className={classes.icon} /> Imprimir / Salvar
              </Button>
            </div>}
          content={() => this.componentRef}
        />
      </div>
    );
  }
}
export default withStyles(styles)(PrintComponentAcertoCoparticipacao);
